import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  Screens: [],
  isSuccess: false,
  message: null,
  status: "idle",
  error: null,
  IsLogin: true,
};

export const fetchScreens = createAsyncThunk("/Screens", async (module, { rejectWithValue }) => {
  try {
    const response = await axiosInstanceAuth.get(`/Screens`, {
      params: module ? { module } : {},
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

const ScreensSlice = createSlice({
  name: "Screens",
  initialState,
  extraReducers: builder => {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchScreens.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchScreens.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Screens = action.payload.Data;
      })
      .addCase(fetchScreens.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export const getScreensDetails = state => state.Screens;
export default ScreensSlice.reducer;
